const IMAGES = {
  terminal:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA0MTJ8MHwxfHNlYXJjaHwxfHxmaW5hbmNpYWwlMjBjaGFydHMlMjBkYXNoYm9hcmR8ZW58MHx8fHwxNzkyMDU3NzczfDA&ixlib=rb-4.1.0&q=85",
  earnings:
    "https://images.unsplash.com/photo-1560221328-12fe60f83ab8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODh8MHwxfHNlYXJjaHwzfHxzdG9jayUyMG1hcmtldCUyMGdyYXBoc3xlbnwwfHx8fDE3OTIwNTc3NzN8MA&ixlib=rb-4.1.0&q=85",
};

export const Platform = () => {
  return (
    <section
      id="platform"
      data-testid="platform-section"
      className="py-24 md:py-32 px-6 lg:px-12 border-b border-grove-bsub"
    >
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-16 pb-6 border-b border-grove-bsub">
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-grove-mid mb-2">
              01 / Terminal Architecture
            </p>
            <h2 className="font-disp text-3xl md:text-5xl text-grove-ink">
              Structured Intelligence at Scale
            </h2>
          </div>
          <p className="text-sm text-grove-mute max-w-sm mt-4 md:mt-0">
            Bridging SEC filings, conference transcripts, and real-time
            community chatter into an active analyst canvas.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8">
          <div
            data-testid="terminal-main-visual"
            className="lg:col-span-8 rounded-xl overflow-hidden border border-grove-bstrong relative min-h-[420px] shadow-sm"
          >
            <img
              src={IMAGES.terminal}
              alt="Analytical workspace showing financial charts and performance dashboards"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover eq-drift"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
            <div className="absolute inset-0 p-8 flex flex-col justify-between text-white z-10">
              <div className="flex justify-between items-start">
                <span className="font-mono text-xs bg-white/20 backdrop-blur px-3 py-1 rounded">
                  Module: Thesis Engine v1
                </span>
                <span className="font-mono text-xs text-emerald-300">
                  Live Synthesis Active
                </span>
              </div>
              <div>
                <div className="font-mono text-xs text-emerald-300 uppercase tracking-wider mb-1">
                  Coverage Synthesis
                </div>
                <h3 className="font-disp text-2xl md:text-3xl text-white font-medium">
                  Automated SEC 10-K &amp; Peer Benchmarking
                </h3>
                <p className="text-xs text-white/80 mt-2 max-w-md">
                  Extracts unit economics, risk disclosures, and shifts in
                  operational guidance instantly.
                </p>
              </div>
            </div>
          </div>

          <div
            data-testid="earnings-matrix-visual"
            className="lg:col-span-4 rounded-xl overflow-hidden border border-grove-bstrong relative min-h-[420px] shadow-sm"
          >
            <img
              src={IMAGES.earnings}
              alt="Monitor displaying stock market earnings graphs"
              loading="lazy"
              className="absolute inset-0 w-full h-full object-cover eq-drift"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-transparent"></div>
            <div className="relative z-10 text-white h-full flex flex-col justify-end p-8">
              <span className="font-mono text-xs bg-white/20 px-2.5 py-1 rounded inline-block mb-3 w-fit">
                Earnings Radar
              </span>
              <h3 className="font-disp text-2xl text-white">
                Consensus &amp; Guidance Shifts
              </h3>
              <p className="text-xs text-white/80 mt-2">
                Real-time transcript question extraction and management
                sentiment classification.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
